module.exports = __webpack_public_path__ + "static/media/clock.e2684f4a.svg";